import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from '../../../../common/table'
import { schema } from './constant'
import {
  selectCellData,
  selectIds,
  selectIsLoading,
  selectSortTable,
  sort,
} from './store/slice'

export const BusinessProvinceTable = ({ isDynamicReport }) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoading)
  const sortTable = useSelector(selectSortTable)

  const changeSort = (data) => {
    dispatch(sort(data))
  }

  return (
    <Table
      ids={ids}
      isLoading={isLoading}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      autoHeightMax={isDynamicReport ? undefined : 500}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectCellData}
      changeSort={changeSort}
      sort={sortTable}
      schema={Object.values(schema).map((item) => {
        return {
          title: item.label,
          colId: item.key,
          isI18n: true,
          sortable: !isDynamicReport,
          thStyle: item.thStyle,
          render: (val, { locale }) => {
            switch (item.key) {
              case schema.numberBusiness.key:
              case schema.totalPercentCompanies.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}

BusinessProvinceTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
